import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const IntroductionComponent = () => {

    const calendlyLink = "https://calendly.com/trbai-info";

    const onBookConsultation = () => {
        if (typeof window.Calendly !== "undefined") {
            window.Calendly.initPopupWidget({ url: calendlyLink });
        } else {
            console.error("Calendly script is not loaded.");
            alert("Calendly is not ready yet. Please try again in a moment.");
        }
    }

    return (
        <Fragment>
            <section id="home" className="hero section">

                <img src="assets/img/Banner/office team TRB Banner.jpg" alt="Welcome to Tech Resource Bench" data-aos="fade-in" className="" />

                <div className="container">
                    <div className="row justify-content-center" data-aos="zoom-out">
                        <div className="col-xl-7 col-lg-9 text-center">
                            <h1>Welcome to Tech Resource Bench (TRB)</h1>
                            <br />
                            <h2>Empowering Digital Transformations with AI-Powered Solutions</h2>
                        </div>
                    </div>
                    <div className="text-center" data-aos="zoom-out" data-aos-delay="100">
                        <button className="btn-get-started" onClick={onBookConsultation}>Book a Consultation</button>
                    </div>

                    <div className="row gy-4 mt-5">
                    <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-small" data-aos="zoom-out" data-aos-delay="100">
                        <Link to="/service/digital-consultancy">
                            <div className="icon-box">
                                <div className="icon"><img src="assets/img/consultansy/PNG/consultant-9PNG.png" alt="" /></div>
                                <h4 className="title">Digital Consultancy</h4>
                                {/* <p className="description">Voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi</p> */}
                            </div>
                        </Link>
                    </div>

                    <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-small" data-aos="zoom-out" data-aos-delay="200">
                        <Link to="/service/resource-augmentation">
                            <div className="icon-box">
                                <div className="icon"><img src="assets/img/resource/PNG/resource-34PNG.png" alt="" /></div>
                                <h4 className="title">Resource Augmentation</h4>
                                {/* <p className="description">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis</p> */}
                            </div>
                        </Link>
                    </div>

                    <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-small" data-aos="zoom-out" data-aos-delay="300">
                        <Link to="/service/ai">
                            <div className="icon-box">
                                <div className="icon"><img src="assets/img/ai/PNG/AI-24PNG.png" alt="" /></div>
                                <h4 className="title">Artificial Intelligence</h4>
                                {/* <p className="description">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis</p> */}
                            </div>
                        </Link>
                    </div>

                    <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-small" data-aos="zoom-out" data-aos-delay="400">
                        <Link to="/service/data-science">
                            <div className="icon-box">
                                <div className="icon"><img src="assets/img/analytics/PNG/analytic icons-23x.png" alt="" /></div>
                                <h4 className="title">Data science & Analytics</h4>
                                {/* <p className="description">Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore</p> */}
                            </div>
                        </Link>
                    </div>

                    <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-small" data-aos="zoom-out" data-aos-delay="500">
                        <Link to="/service/software-development">
                            <div className="icon-box">
                                <div className="icon"><img src="assets/img/software/PNG/software-16PNG.png" alt="" /></div>
                                <h4 className="title">Software Development</h4>
                                {/* <p className="description">Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia</p> */}
                            </div>
                        </Link>
                    </div>

                    <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-small" data-aos="zoom-out" data-aos-delay="600">
                        <Link to="/service/ui-ux">
                            <div className="icon-box">
                                <div className="icon"><img src="assets/img/UiUx/PNG/UI-UX-13PNG.png" alt="" /></div>
                                <h4 className="title">Innovative Design</h4>
                                {/* <p className="description">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis</p> */}
                            </div>
                        </Link>
                    </div>
                    {/* <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-small" data-aos="zoom-out" data-aos-delay="500">
                        <Link to="/service/seo">
                            <div className="icon-box">
                                <div className="icon"><img src="assets/img/SEO/PNG/SEO-32PNG.png" alt="" /></div>
                                <h4 className="title">Search Engine Optimization</h4>
                                <p className="description">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis</p>
                            </div>
                        </Link>
                    </div> */}
                </div>
                </div>

            </section>
            {/* Calendly Badge Widget */}
            <link
                href="https://assets.calendly.com/assets/external/widget.css"
                rel="stylesheet"
            />
            <script
                src="https://assets.calendly.com/assets/external/widget.js"
                type="text/javascript"
                async
            ></script>

        </Fragment>
    );
};

export { IntroductionComponent };
